var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-section',{staticStyle:{"font-size":"15px"},attrs:{"theme":"blue","title":"其他人壽保單","isLoading":_vm.isLoading,"datas":_vm.datas,"_fields":[
      {
        name: '公司/保單號碼\n險種',
        key: 'productname',
        width: 274,
        sortable: true,
        orderByMultiKey: ['sortProductname'],
        orderByMultiType: ['asc']
      },
      {
        name: '要保人',
        key: 'applicant',
        width: 79,
        sortable: true,
        orderByMultiKey: ['sortApplicant'],
        orderByMultiType: ['asc']
      },
      {
        name: '被保人',
        key: 'insuredpersonname',
        width: 79,
        sortable: true,
        orderByMultiKey: ['sortInsuredpersonname'],
        orderByMultiType: ['asc']
      },
      { name: '繳費\n年期', key: 'year', width: 55 },
      {
        name: '承保\n對象',
        key: 'relation',
        width: 49,
        thClassName: 'text-left',
        className: 'text-left'
      },
      {
        name: '投保始期',
        key: 'insurancedate',
        width: 95,
        className: 'text-left',
        sortable: true,
        orderByMultiKey: ['sortInsuranceADDate'],
        orderByMultiType: ['asc']
      },
      {
        name: '保額',
        key: 'amountofinsurance',
        width: 96,
        thClassName: 'text-right',
        className: 'text-right',
       /* sortable: true,
        orderByMultiKey: ['amountofinsurance'],
        orderByMultiType: ['asc'] */
      },
      {
        name: '保費/繳別',
        key: 'bknm',
        width: 138,
        thClassName: 'text-right',
        className: 'text-right',
        sortable: true,
        orderByMultiKey: [
          'sortBknm',
          'isprimarycontract',
          'money',
          'longPremium'
        ],
        orderByMultiType: ['asc', 'adesc', 'asc', 'asc']
      },
      { name: '受益人', key: 'bnf', width: 99 }
    ].concat(_vm._fields),"initShow":_vm.$route.query['OtherLifeInsuranceShow'] !== 'false'},on:{"toggle":function (isShow) { return _vm.$router.assignQuery({ OtherLifeInsuranceShow: isShow }); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return _vm.refresh?[_c('data-table',_vm._b({attrs:{"initSort":_vm.$route.query["OtherLifeInsuranceSort"]
          ? JSON.parse(_vm.$route.query["OtherLifeInsuranceSort"])
          : null},on:{"changeSort":function (sort) {
              var _obj;

              return _vm.$router.assignQuery(( _obj = {}, _obj["OtherLifeInsuranceSort"] = JSON.stringify(sort), _obj ));
    }},scopedSlots:_vm._u([{key:"productname",fn:function(item){return [(item.data.isprimarycontract)?_c('div',[_c('div',{staticClass:"font-13"},[_vm._v("\n            "+_vm._s(((item.data.companyshortname) + "/" + (item.data.policynumber)))+"\n          ")]),_c('div',[_vm._v("\n            "+_vm._s(item.data.productname.split(" ")[1]
                ? ((item.data.productname.split(" ")[0]) + "(" + (item.data.productname.split(" ")[1]) + ")")
                : item.data.productname)+"\n            "),(item.data.prodid)?_c('span',[_vm._v(" ("+_vm._s(item.data.prodid)+") ")]):_vm._e()])]):_c('div',[_c('div',{staticStyle:{"margin-left":"1em","text-indent":"-1em"}},[_c('span',{staticClass:"text-gray",staticStyle:{"text-shadow":"0px 1px grey"}},[_c('strong',[_vm._v("└")])]),_c('span',{staticStyle:{"font-size":"13px"}},[_vm._v("\n              "+_vm._s(((item.data.companyshortname) + "/" + (item.data.policynumber)))+"\n            ")])]),_c('div',{staticStyle:{"margin-left":"1em"}},[_vm._v("\n            "+_vm._s(item.data.productname.split(" ")[1]
                ? ((item.data.productname.split(" ")[0]) + "(" + (item.data.productname.split(" ")[1]) + ")")
                : item.data.productname)+"\n            "),(item.data.prodid)?_c('span',[_vm._v(" ("+_vm._s(item.data.prodid)+") ")]):_vm._e()])])]}},{key:"applicant",fn:function(item){return [_c('span',[_vm._v("\n          "+_vm._s(_vm._f("truncate")(_vm.getFamilyMemberName(item.data.apcid)))+"\n        ")])]}},{key:"insuredpersonname",fn:function(item){return [_c('div',[_vm._v("\n          "+_vm._s(_vm._f("truncate")(item.data.insuredpersonname))+"\n        ")])]}},{key:"year",fn:function(item){return [_vm._v("\n        "+_vm._s(item.data.paymentway == "躉繳" && item.data.producttype == "2" ? "--" : (item.data.year.padLeft(2, "0") + item.data.prd_unit))+"\n      ")]}},{key:"amountofinsurance",fn:function(item){return [(item.data.schemename && item.data.quantity)?_c('div',{staticClass:"text-right pre-formatted"},[_vm._v("\n          "+_vm._s(("計畫" + (item.data.schemename) + "："))+"\n          "+_vm._s(item.data.schemename && item.data.schemename.includes("_1")
              ? ""
              : "日額")+"\n          "+_vm._s(((item.data.quantity) + "元"))+"\n        ")]):_c('div',{staticClass:"text-right"},[_vm._v("\n          "+_vm._s(item.data.amountofinsurance)+"\n        ")])]}},{key:"bknm",fn:function(item){return [(item.data.premium)?_c('div',[_vm._v("\n          "+_vm._s(item.data.money + ' ')+_vm._s(item.data.premium)+"\n        ")]):_vm._e(),_c('div',[_vm._v(_vm._s(item.data.paymentway))]),(item.data.bknm || item.data.card_acnt_no)?_c('div',[_vm._v("\n          "+_vm._s(((item.data.bknm) + "(" + (item.data.card_acnt_no) + ")"))+"\n        ")]):_vm._e()]}},{key:"bnf",fn:function(item){return [_vm._l(({
            bnf_death_nm: '身故',
            bnf_matag_nm: '滿期',
            bnf_annuity_nm: '年金',
            bnf_birth_nm: '祝壽'
          }),function(name,key){return _c('div',{key:key},[(item.data[key])?_c('span',{attrs:{"set":(_vm.names = item.data[key].split(','))}},[_vm._v("\n            "+_vm._s(name)+"：\n            "),_vm._l((_vm.names),function(name,index){return _c('span',{key:index},[_c('truncate-tool',{attrs:{"content":name}}),_vm._v("\n              "+_vm._s(_vm.names.length - 1 > index ? "、" : "")+"\n            ")],1)})],2):_vm._e()])}),(
            !item.data.bnf_death_nm &&
            !item.data.bnf_matag_nm &&
            !item.data.bnf_annuity_nm &&
            !item.data.bnf_birth_nm
          )?_c('div',[_vm._v("\n          一一\n        ")]):_vm._e()]}},{key:"action",fn:function(item){return [(item.data.isMyself)?_c('div',{staticClass:"dropdown"},[_c('a',{staticClass:"btn btn-icon btn-default btn-sm",attrs:{"data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false","role":"button"}},[_c('i',{staticClass:"icon-more"})]),_c('div',{staticClass:"dropdown-menu"},[_c('a',{staticClass:"dropdown-item text-green text-underline",attrs:{"role":"button"},on:{"click":function($event){_vm.toUpdate(item.data)}}},[_vm._v("修改")]),_c('a',{staticClass:"dropdown-item text-green text-underline",attrs:{"role":"button"},on:{"click":function($event){_vm.doDelete(item.data)}}},[_vm._v("刪除")]),(item.data.isprimarycontract)?_c('a',{staticClass:"dropdown-item text-green text-underline",attrs:{"role":"button"},on:{"click":function($event){_vm.toAddSubContract(item.data)}}},[_vm._v("新增附約")]):_vm._e()])]):_vm._e()]}}])},'data-table',
        Object.assign({}, props, {
          datas: _vm.proccessDatas
        })
      ,false))]:undefined}}])})}
var staticRenderFns = []

export { render, staticRenderFns }